<template>
  <div class="create-driver">
    <h3 class="title">Create driver</h3>
    <b-steps v-model="activeStep" size="is-small" :has-navigation="false">
      <b-step-item label="ลงทะเบียนคนขับ" icon="account-key">
        <Signup :disable="false" :localData="null" @success="onSetLocalData" />
      </b-step-item>
      <b-step-item label="ยืนยันข้อมูล" icon="account-key">
        <Signup :disable="true" :localData="localData" />
        <div style="text-align: end">
          <b-button :loading="loading" @click="onConfirmSignup" type="is-primary"
            >ยืนยันข้อมูล</b-button
          >
        </div>
      </b-step-item>
      <b-step-item label="สำเร็จ" icon="account-plus">
        <div style="text-align: center">
          <h1>{{ status }}</h1>
          <b-button @click="SignUpAgian" type="is-primary">ลงทะเบียนอีกครั้ง</b-button>
        </div>
      </b-step-item>
    </b-steps>
  </div>
</template>

<script>
import { createDriver } from "@/customGraphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
export default {
  components: {
    Signup: () => import(`@/components/Signup`),
  },
  data() {
    return {
      activeStep: null,
      status: null,
      localData: null,
      loading: false,
    };
  },
  methods: {
    onSetLocalData(data) {
      this.status = null;
      this.localData = data;
      this.activeStep = 1;
    },
    async onConfirmSignup() {
      this.loading = true;
      const header = { "Access-Control-Allow-Origin": "*" };
      await this.$http
        .post(
          process.env.VUE_APP_API_CONFIRMSIGNUP + "/confirmSignup",
          { username: this.localData.phone_no },
          { header }
        )
        .then((response) => {
          if (response.data.statusCode === 200) {
            this.onConfirmSuccess();
            this.activeStep = 2;
          } else if (response.data.statusCode === 400 && 
                     response.data.error && 
                     response.data.error.code === "NotAuthorizedException" &&
                     response.data.error.message.includes("User cannot be confirmed. Current status is CONFIRMED")) {
            // User is already confirmed, proceed to create driver
            this.onConfirmSuccess();
            this.activeStep = 2;
          } else {
            this.$buefy.notification.open({
              message: `ยืนยันผิดพลาด: ${response.data.error.message || response.data.error}`,
              type: "is-danger",
              duration: 5000,
              queue: false,
            });
          }
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.notification.open({
            message: `เกิดข้อผิดพลาด: ${error.message || 'กรุณาลองใหม่อีกครั้ง'}`,
            type: "is-danger",
            duration: 5000,
            queue: false,
          });
        });
      console.log("onConfirmSignup");
      this.loading = false;
    },
    async onConfirmSuccess() {
      try {
        delete this.localData.password;
        await API.graphql(graphqlOperation(createDriver, { input: this.localData }));
        this.status = "ลงทะเบียนคนขับสำเร็จ";
      } catch (error) {
        this.status = error;
      }
    },
    SignUpAgian() {
      this.activeStep = 0;
      this.localData = null;
    },
  },
};
</script>

<style scoped>
.create-driver {
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* padding: 10px; */
}
h1 {
  font-size: 30px;
  font-weight: bold;
}
>>> .label {
  font-size: 12px;
}
.title {
  padding: 20px;
  margin: 0;
  font-size: 24px;
  margin: 0;
  position: sticky;
  top: 0px;
  background-color: white;
}
</style>
